import Cookie from 'js-cookie'

export const getAuthToken = () => Cookie.get('token')
export const getCookie = () => Cookie.get()

export default getAuthToken